package one.healthium.profile.navigation.log_weight

import androidx.compose.runtime.Composable
import one.healthium.log_weight.ui.LogWeightScreen

@Composable
fun LogWeightContent(component: LogWeightComponent) {
    LogWeightScreen(component.taskId, component)
}